import core from '@/admin/core';
import myAttributes from '@/composition/myAttributes';

export interface Lottery {
  id: string;
  title: string;
  thumbnail: string;
  description?: string;
  annotation?: string;
  purchaseAuthority?: object;
  enablePurchaseByPayment: boolean;
  price: number;
  enablePurchaseByGift: boolean;
  giftIds: string[];
  isRequiredShippingAddress: boolean;
  isRequiredShippingFee: boolean;
  shippingFee: number;
  additionalShippingFeeCount: number;
  enable10Draws: boolean;
  enable10DrawsGiftPrize: boolean;
  enableLosePrize: boolean;
  showOutOfStockLabel: boolean;
  accessStartDate?: number;
  accessEndDate?: number;
  purchaseStartDate?: number;
  purchaseEndDate?: number;
  plannedSalesQuantity: number;
  salesQuantity: number;
  lotteryStatus: string;
  displayOrder: number;
  isDeleted: boolean;
  deleteDate?: number;
  createdAt: number;
  updatedAt: number;
}

export const getLotteries = async () => {
  if (myAttributes.myRequestPermissions?.lotteries) {
    try {
      const result = await core.httpClient.get('/v2/lottery/public/queries/getLotteryList');
      return result.data as Lottery[];
    } catch (e) {
      return [];
    }
  } else return [];
};
